// src/components/Students/StudentHome.js
import React from 'react';
import { Link } from 'react-router-dom';

function StudentHome() {
  return (
    <div className="container">
      <h1>Student Dashboard</h1>
      <p>Welcome to your student portal. Access your academic information and tools below.</p>
      
      <div className="student-actions">
        <h2>Quick Actions</h2>
        <div className="action-grid">
          <Link to="/schedule" className="action-card">
            <h3>📅 My Schedule</h3>
            <p>View your daily class schedule</p>
          </Link>
          
          <Link to="/attendance" className="action-card">
            <h3>📊 My Attendance</h3>
            <p>Check your attendance record</p>
          </Link>
          
          <Link to="/groups" className="action-card">
            <h3>👥 My Groups</h3>
            <p>See your assigned groups and classmates</p>
          </Link>
          
          <Link to="/grades" className="action-card">
            <h3>📈 Grades & Progress</h3>
            <p>View your academic progress</p>
          </Link>
        </div>
      </div>
      
      <style jsx>{`
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }
        
        .action-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }
        
        .action-card {
          display: block;
          padding: 20px;
          border: 1px solid #ddd;
          border-radius: 8px;
          text-decoration: none;
          color: inherit;
          transition: all 0.2s;
        }
        
        .action-card:hover {
          border-color: #1976d2;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          transform: translateY(-2px);
        }
        
        .action-card h3 {
          margin: 0 0 10px 0;
          color: #1976d2;
        }
        
        .action-card p {
          margin: 0;
          color: #666;
        }
      `}</style>
    </div>
  );
}

export default StudentHome;
